// IMPORTANT Any updates to this file should also be made to:
// profile-engine/engine/lib/typedefs/qualifier_types.py

export enum QualifierDataTypes {
  HouseholdId = "hhid",
  BlockgraphId = "bgid",
  Values = "values",
  Number = "number",
  String = "string",
  Date = "date",
  Boolean = "boolean",
  Canoe = "canoe"
}
